import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError, handleSuccess } from "Helper";

// Initial state
const initialState = {
  mediaMTXStatus: {
    isRestarting: false,
    successMessage: null,
    errorRestart: null,
  },
};

// Thunk action for restarting IP camera
export const mediaMTXStatus = createAsyncThunk(
  "ipCam/mediaMTXStatus",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi(); // Menggunakan fetchApi
      const url = "/streaming-device/restart-camera";
      const result = await api.get(url);
      handleSuccess(result?.data?.message)
      return result?.data || "Camera restarted successfully";
    } catch (error) {
      handleError(error);
      console.error(error);
      return rejectWithValue(error.response?.data || "Failed to restart camera");
    }
  }
);

// Slice definition
const mediaMTXSlice = createSlice({
  name: "mediaMTX",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mediaMTXStatus.pending, (state) => {
        state.mediaMTXStatus.isRestarting = true;
        state.mediaMTXStatus.successMessage = null;
        state.mediaMTXStatus.errorRestart = null;
      })
      .addCase(mediaMTXStatus.fulfilled, (state, action) => {
        state.mediaMTXStatus.isRestarting = false;
        state.mediaMTXStatus.successMessage = action.payload;
        state.mediaMTXStatus.errorRestart = null;
      })
      .addCase(mediaMTXStatus.rejected, (state, action) => {
        state.mediaMTXStatus.isRestarting = false;
        state.mediaMTXStatus.errorRestart = action.payload;
      });
  },
});

export default mediaMTXSlice.reducer;
